<template lang="html">
  <div class="loading-component-v2">
    <div class="holder">
      <div class="preloader"><div></div><div></div><div></div><div></div><div></div><div></div><div></div><div></div><div></div><div></div></div>
    </div>
  </div>
</template>

<script>
export default {
}
</script>
